import React from 'react';
import { TrackConfig } from '../types';
import './TrackSelector.css';

interface TrackSelectorProps {
  tracks: TrackConfig[];
  onTrackSelect: (track: TrackConfig) => void;
}

export const TrackSelector: React.FC<TrackSelectorProps> = ({ tracks, onTrackSelect }) => {
  return (
    <div className="track-selector">
      <h2>Select a Track</h2>
      <div className="track-list">
        {tracks.map((track, index) => (
          <div
            key={index}
            className="track-item"
            onClick={() => onTrackSelect(track)}
          >
            <h3>{track.name}</h3>
            <p>Host: {track.host}:{track.wsPort}</p>
            <p>URL: {track.url}</p>
          </div>
        ))}
      </div>
    </div>
  );
}; 